module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c2nBk"))).then(() => parcelRequire('1iHdE'));